import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import brokeragesReducer, * as brokerages from './brokerages';
import filtersReducer, * as filters from './filters';
import lendersByProductsReducer, { actions as lendersByProducts } from './lendersByProducts';
import productsReducer, * as products from './products';
import settingsReducer, * as settings from './settings';
import usersReducer, * as users from './users';

export const rootReducer = {
  brokerages: brokeragesReducer,
  filters: filtersReducer,
  lendersByProducts: lendersByProductsReducer,
  products: productsReducer,
  settings: settingsReducer,
  users: usersReducer,
};

export type RootState = {
  [K in keyof typeof rootReducer]: ReturnType<(typeof rootReducer)[K]>;
};

export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;
export type AppGetState = () => RootState;

// Result of a request thunk, inspected by callers via action.type; payload and error.data derive from untyped API responses.
export type RequestResultAction = {
  type: string;
  payload?: any;
  error?: { data?: any; message?: string; status?: number | null };
};

export default {
  brokerages,
  filters,
  lendersByProducts,
  products,
  settings,
  users,
};
